'use client'

import { useState, useTransition } from 'react'
import type { ResidentPriceCategoryParams } from '@/api/endpoints'
import { getResidentPriceCategory, ResidentPriceCategoryResponse } from '@/app/actions/resident'
import { ApiError } from '@/root/shared-types/api/ApiError'

interface UseResidentPriceCategoryReturn {
  data: ResidentPriceCategoryResponse | null
  error: ApiError | null
  fetchResidentPriceCategory: (params: ResidentPriceCategoryParams) => void
  loading: boolean
  resetError?: () => void
}

export const useResidentPriceCategory = (): UseResidentPriceCategoryReturn => {
  const [data, setData] = useState<ResidentPriceCategoryResponse | null>(null)
  const [error, setError] = useState<ApiError | null>(null)

  const [isPending, startTransition] = useTransition()

  const fetchResidentPriceCategory = (params: ResidentPriceCategoryParams) => {
    setError(null)

    startTransition(async () => {
      const result = await getResidentPriceCategory(params)

      if ('error' in result) {
        setError(result.error)
        setData(null)
        return
      }

      setData(result.data)
      setError(null)
    })
  }

  const resetError = () => setError(null)

  return {
    data,
    error,
    loading: isPending,
    fetchResidentPriceCategory,
    resetError,
  }
}
